import axios from 'axios';

export default {
    post: function(itemId, text, datasourceId) {
        const endpoint = '/aha-service/Promo/RegisterEvent';

        // Add analytics call
        return axios({
            method: 'post',
            url: endpoint,
            responseType: 'text',
            data: {
                'itemID': itemId,
                'text': text,
                'datasourceId': datasourceId
            }
        }).catch(error => {
            // eslint-disable-next-line
            console.log('RegisterEvent error: ' + error);
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/resources/register-event.js